import React, { useState, useRef, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { fetchEans, resetEanPage, updateEanPage, updateEanSearchStr } from "../redux/reducers/EansReducer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { user } from "../redux/reducers/UserReducer";

interface Option {
  value: string;
  label: string;

}

interface SearchSelectProps {
  options: Option[];
  onOptionSelect: (option: Option) => void;
  fetchMoreOptions?: () => void;
  value?: any;
  onInputChange?: (value: string) => void;
  onBlur?: () => void;
  className?: string;
  placeholder?: string;
  InputClassName?: string;
  crossClassname?: string;
}

const SearchSelect: React.FC<SearchSelectProps> = ({
  options,
  onOptionSelect,
  fetchMoreOptions,
  value,
  onInputChange,
  className,
  placeholder = "Search...",
  InputClassName = '',
  crossClassname = ""
}) => {
  const [onOption, setOnOption] = useState<Option | null>();
  const [filteredOptions, setFilteredOptions] = useState<Option[]>(options);
  const [searchTerm, setSearchTerm] = useState<string>(value?.label ?? "");
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const userData = useSelector(user);

  const dispatch = useDispatch<AppDispatch>();
   const EansLoading = useSelector(
      (state: RootState) => state.eanReducer.eans.isLoading
    );

  useEffect(() => {
    // if(searchTerm?.length)
    setFilteredOptions(
      options.filter((option) => {
        if (typeof option.label === "string") {
          return option.label.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return JSON.stringify(option.label)
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        }
      })
    );
  }, [searchTerm, options]);

  useEffect(() => {
    if (value && value?.label) setSearchTerm(value.label);
    if (!value) setSearchTerm("");
  }, [value]);

  const openDropdown = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
    setIsPopoverOpen(true);
  };

  const closeDropdown = () => {
    setIsPopoverOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleScroll = useCallback(() => {
    if (dropdownRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current;
      const isAtBottom = scrollHeight - scrollTop - clientHeight <= 1;

      if (isAtBottom && fetchMoreOptions) {
        fetchMoreOptions();
      }
    }
  }, [fetchMoreOptions]);

  const handleOptionClick = (option: any) => {
    onOptionSelect(option);
    if (option?.label) setSearchTerm(option.label);
    closeDropdown();
  };

  const handleRemoveSelectedOption = () => {
    // setSearchTerm("");
    // if (onInputChange) onInputChange("");
    handleOptionClick(null);
  };
  const handleBlur = () => {
    if (onOption) {
      handleOptionClick(onOption)
      setOnOption(null)
    }
    if (value && value.label) {
      setSearchTerm(value.label);
    } else {
      setSearchTerm("");
      dispatch(updateEanSearchStr(""))
      dispatch(resetEanPage())
    }
  };
  useEffect(() => {
    const updateDropdownPosition = () => {
      if (inputRef.current && isPopoverOpen) {
        const rect = inputRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width,
        });
      }
    };

    window.addEventListener('resize', updateDropdownPosition);
    window.addEventListener('scroll', updateDropdownPosition, true);

    return () => {
      window.removeEventListener('resize', updateDropdownPosition);
      window.removeEventListener('scroll', updateDropdownPosition, true);
    };
  }, [isPopoverOpen]);


  return (
    <div className={`${className}`} onCopy={(e) => {
      e.preventDefault()
      navigator.clipboard.writeText(searchTerm);
    }}>
      <div className="relative flex ">
        {/* <div className={`${StrClassName}`}>
          {searchTerm}
        </div> */}
        <input
          ref={inputRef}
          disabled={userData?.role?.includes("viewer")}
          type="text"
          onBlur={() => handleBlur()}
          value={searchTerm}
          onChange={(e) => {
            if (onInputChange) onInputChange(e.target.value);
            setSearchTerm(e.target.value);
          }}
          onFocus={openDropdown}
          placeholder={placeholder}
          className={`${userData?.role?.includes("viewer") ? "cursor-not-allowed":"cursor-pointer"} border ${InputClassName} w-full 
          border border-solid border-gray-300 font-poppins rounded-md font-normal lg:text-[12px] overflow-x-auto max-w-[200px]sm:text-[10px] css-nxiuxh-container   focus:outline-none focus:ring-0 pr-8`}
        />
        <div>
          {value?.label && searchTerm.trim() && (
            <div onClick={() => {
        if (userData?.role?.includes("viewer")) return;
        handleRemoveSelectedOption();
      }}
              className={`absolute  rounded-full text-gray-500  flex justify-center items-center pr-2
          top-1/2 transform -translate-y-1/2
 
          ${crossClassname}
        ${userData?.role?.includes("viewer") ? "cursor-not-allowed":"cursor-pointer"} right-[1px]  h-[22px]`}>
              <span className={`font-semibold w-full text-[15px] 
         flex items-center pl-1.5 justify-center  rounded-full `}><svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg></span>
            </div>
          )}
        </div>


      </div>
      {/* {/* {value?.label ? (
                        <div
                          title="Clear All"
                          onClick={handleRemoveSelectedOption}
                          className="flex absolute items-center right-[-8px] top-0 "
                        >
                          <MdCancel className="text-[#e31c23] w-5 h-5 cursor-pointer" />
                        </div>
                      ) : (
                        ""
                      )} */}

      {isPopoverOpen &&
        createPortal(
          <div
            ref={dropdownRef}
            style={{
              position: "absolute",
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              width: dropdownPosition.width,
              zIndex: 0,
               pointerEvents: EansLoading ? "none" : "auto",
            }}
            onScroll={handleScroll}
            className="max-h-40 overflow-y-auto border text-[12px] border-gray-300 bg-white rounded-md shadow-lg scroll-smooth  border-solid  font-poppins w-full font-normal min height:26px"
          >
            {filteredOptions.length ? (
              filteredOptions.map((option) => (
                <div
                  key={option.value}
                  // onMouseEnter={() => {
                  //   setInsideSelection(true)
                  // }}
                  onMouseLeave={() => {
                    setOnOption(null)
                  }}
                  onMouseOver={() => setOnOption(option)}
                  onClick={(e) => {
                    handleOptionClick(option)
                  }
                  } // Handle option click here
                  className={`"px-4 py-2 z-50 ${userData?.role?.includes("viewer") ? "cursor-not-allowed":"cursor-pointer"}  hover:bg-gray-100"`}
                >
                  {option.label}
                </div>
              ))
            )
              : (value && value?.label) ? (
                <div
                  // key={option.value}
                  // onMouseEnter={() => {
                  //   setInsideSelection(true)
                  // }}
                  // onMouseLeave={() => {
                  //   setOnOption(null)
                  // }}
                  // onMouseOver={() => setOnOption(option)}
                  // onClick={(e) =>{
                  //   handleOptionClick(option)}
                  //   } // Handle option click here
                  className={`"px-4 py-2 z-50 ${userData?.role?.includes("viewer") ? "cursor-not-allowed":"cursor-pointer"} hover:bg-gray-100"`}
                >
                  {value?.label}
                </div>
              )
                : (
                  <div className="px-4 py-2 text-gray-500">{EansLoading ? "Loading":"No records found"}</div>
                )}
          </div>,
          document.body
        )
      }
    </div>
  );
};

export default SearchSelect;
